/* Sweet'n Savoury Studio — theme scripts */
(function () {
  'use strict';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ROOT = document.documentElement;
  var BODY_DS = (document.body && document.body.dataset) || {};
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOTION = BODY_DS.motion !== 'off' && !REDUCED;
  var HAPTICS = BODY_DS.haptics !== 'off';
  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Haptics ----------
     Android/Chrome: Vibration API. iOS Safari 18+: toggling a hidden <input switch> gives a system tap.
     Desktop: no-op. Must be called from a user gesture. */
  var iosSwitch = null;
  function ensureIosSwitch() {
    if (iosSwitch || !/iPhone|iPad|iPod/.test(navigator.userAgent)) return iosSwitch;
    var label = document.createElement('label');
    label.setAttribute('aria-hidden', 'true');
    label.setAttribute('data-sss-haptic-el', '');
    label.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
    var input = document.createElement('input');
    input.type = 'checkbox'; input.setAttribute('switch', ''); input.tabIndex = -1;
    label.appendChild(input);
    document.body.appendChild(label);
    iosSwitch = label;
    return iosSwitch;
  }
  var PATTERNS = { tap: 8, select: [6, 30, 6], success: [12, 60, 24], error: [30, 50, 30] };
  function haptic(kind) {
    if (!HAPTICS) return;
    var p = PATTERNS[kind] || PATTERNS.tap;
    try {
      if (navigator.vibrate) { navigator.vibrate(p); return; }
      var sw = ensureIosSwitch();
      if (sw) {
        sw.click();
        if (kind === 'success' || kind === 'error') setTimeout(function () { sw.click(); }, 90);
      }
    } catch (err) {}
  }
  window.SSS = window.SSS || {};
  window.SSS.haptic = haptic;

  function showError(form, msg) {
    var el = form.querySelector('[data-sss-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
    if (msg) {
      haptic('error');
      form.classList.remove('is-shake'); void form.offsetWidth; form.classList.add('is-shake');
      var b = form.querySelector('.is-busy'); if (b) b.classList.remove('is-busy');
    }
  }

  function markDone(form) {
    var wrap = form.closest('[data-sss-signup]');
    if (!wrap) return;
    wrap.classList.add('is-done');
    haptic('success');
    var ok = wrap.querySelector('[data-sss-success]');
    if (ok) { ok.hidden = false; }
  }

  function validate(form) {
    var email = form.querySelector('input[type="email"]');
    var consent = form.querySelector('[data-sss-consent]');
    if (!email || !EMAIL_RE.test(email.value.trim())) { showError(form, 'Enter a valid email address.'); email && email.focus(); return false; }
    if (consent && !consent.checked) { showError(form, 'Tick the box so we can email you.'); consent.focus(); return false; }
    showError(form, '');
    return true;
  }

  // Mailchimp JSONP submit (keeps people on the page)
  function submitMailchimp(form) {
    var action = form.getAttribute('action') || '';
    var url = action.replace('/post?', '/post-json?');
    if (url === action) { form.submit(); return; }
    var cb = 'sssMc' + Date.now();
    var params = new URLSearchParams(new FormData(form)).toString();
    var script = document.createElement('script');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    window[cb] = function (res) {
      delete window[cb];
      script.remove();
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
      if (res && res.result === 'success') { markDone(form); }
      else {
        var msg = (res && res.msg) ? String(res.msg).replace(/<[^>]*>/g, '').replace(/^\d+\s*-\s*/, '') : 'Something went wrong. Please try again.';
        if (/already subscribed/i.test(msg)) { markDone(form); return; }
        showError(form, msg);
      }
    };
    script.src = url + '&' + params + '&c=' + cb;
    script.onerror = function () { if (btn) btn.disabled = false; showError(form, 'Could not reach the mailing list. Please try again.'); };
    document.body.appendChild(script);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-sss-form]')) return;
    if (!validate(form)) { e.preventDefault(); return; }
    if (form.hasAttribute('data-sss-mailchimp')) { e.preventDefault(); submitMailchimp(form); return; }
    var sb = form.querySelector('button[type="submit"]'); if (sb) sb.classList.add('is-busy');
    // Shopify customer form: let it post normally; the theme shows the success state on return.
  });

  // Archive filter
  document.querySelectorAll('[data-sss-archive]').forEach(function (root) {
    var chips = root.querySelectorAll('[data-filter]');
    var figs = root.querySelectorAll('[data-tag]');
    var count = root.querySelector('[data-count]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        var n = 0;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        haptic('select');
        var apply = function () {
          figs.forEach(function (fig) {
            var show = f === 'all' || fig.getAttribute('data-tag') === f;
            fig.classList.toggle('is-hidden', !show);
            if (show) n++;
          });
          if (count) count.textContent = '(' + String(n).padStart(2, '0') + ')';
        };
        if (MOTION) {
          figs.forEach(function (fig) { fig.classList.add('is-leaving'); });
          setTimeout(function () {
            apply();
            requestAnimationFrame(function () { figs.forEach(function (fig) { fig.classList.remove('is-leaving'); }); });
          }, 220);
          return;
        }
        apply();
        if (count) count.textContent = '(' + String(n).padStart(2, '0') + ')';
      });
    });
  });


  /* ---------- Tap haptics on interactive elements ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sss-haptic-el]')) return;
    var el = e.target.closest('button, .sss-btn, .sss-header__cta, .sss-chip, .sss-header__link, .sss-arrow-link, input[type="checkbox"]');
    if (!el || el.matches('[data-filter]') || el.type === 'submit') return; // chips/submit have their own feedback
    haptic('tap');
  }, true);
  document.addEventListener('click', function (e) {
    var el = e.target.closest('button[type="submit"]');
    if (el && !e.target.closest('[data-sss-haptic-el]')) haptic('tap');
  });

  /* ---------- Sticky header: solid after the hero, hides on scroll down ---------- */
  var header = document.querySelector('[data-sss-header]');
  var progress = null;
  if (header) {
    var isOverlay = header.classList.contains('sss-header--overlay');
    var spacer = null;
    if (!isOverlay) {
      spacer = document.createElement('div');
      spacer.className = 'sss-header-spacer';
      header.parentNode.insertBefore(spacer, header.nextSibling);
    }
    var lastY = window.scrollY, ticking = false;
    var threshold = function () { var hero = document.querySelector('.sss-hero'); return hero ? hero.offsetHeight * 0.6 : header.offsetHeight; };
    var onScroll = function () {
      var y = window.scrollY;
      var stuck = y > threshold();
      if (stuck !== header.classList.contains('is-stuck')) {
        header.classList.toggle('is-stuck', stuck);
        if (isOverlay) header.classList.toggle('sss-header--overlay', !stuck);
        if (spacer) { spacer.style.height = header.offsetHeight + 'px'; spacer.classList.toggle('is-on', stuck); }
      }
      var goingDown = y > lastY + 4, goingUp = y < lastY - 4;
      if (stuck && goingDown && !header.contains(document.activeElement)) header.classList.add('is-hidden');
      if (goingUp || !stuck) header.classList.remove('is-hidden');
      lastY = y;
      if (progress) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      }
      if (heroMedia && y < window.innerHeight * 1.2) heroMedia.style.transform = 'translate3d(0,' + (y * 0.22).toFixed(1) + 'px,0)';
      ticking = false;
    };
    var heroMedia = MOTION ? document.querySelector('.sss-hero__media') : null;
    if (MOTION && !DESIGN_MODE) {
      progress = document.createElement('div');
      progress.className = 'sss-progress';
      progress.setAttribute('aria-hidden', 'true');
      document.body.appendChild(progress);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ---------- Image frames for hover zoom + reveal ---------- */
  var IMG_SCOPES = '.sss-fig, .sss-pair, .sss-shell__media, .sss-cta__media, .sss-split__media';
  document.querySelectorAll(IMG_SCOPES).forEach(function (scope) {
    scope.querySelectorAll(':scope > img, :scope > picture').forEach(function (img) {
      if (img.parentNode.classList.contains('sss-zoom')) return;
      var wrap = document.createElement('span');
      wrap.className = 'sss-zoom';
      if (img.classList.contains('sss-pair__offset')) { wrap.style.marginTop = '64px'; img.classList.remove('sss-pair__offset'); }
      if (img.classList.contains('sss-poster')) { wrap.style.display = 'inline-block'; wrap.style.maxWidth = '100%'; }
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if (MOTION && !DESIGN_MODE && 'IntersectionObserver' in window) {
    ROOT.classList.add('sss-motion');
    var TEXT = '.sss-section .sss-label, .sss-h1, .sss-h2, .sss-display, .sss-quote, .sss-section .sss-body, .sss-rows, .sss-feature, .sss-tier, .sss-pillar, .sss-stats > div, .sss-step, .sss-cap, .sss-rte > *, .sss-sign, .sss-join__form, .sss-cta__form, .sss-footer__wordmark, .sss-filters';
    var groups = new Map();
    document.querySelectorAll(TEXT).forEach(function (el) {
      if (el.closest('.sss-hero') || el.closest('.sss-popup')) return;
      el.setAttribute('data-rv', '');
      var p = el.parentElement; var i = groups.get(p) || 0; groups.set(p, i + 1);
      el.style.setProperty('--rv-d', Math.min(i * 0.08, 0.4) + 's');
    });
    document.querySelectorAll('.sss-zoom').forEach(function (el) {
      if (el.closest('.sss-popup')) return;
      el.setAttribute('data-rv', 'img');
      var p = el.closest('.sss-grid-archive, .sss-grid-3, .sss-pair');
      if (p) { var idx = Array.prototype.indexOf.call(p.querySelectorAll('.sss-zoom'), el); el.style.setProperty('--rv-d', ((idx % 4) * 0.1) + 's'); }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('[data-rv]').forEach(function (el) { io.observe(el); });
    // safety: never leave content hidden
    setTimeout(function () { document.querySelectorAll('[data-rv]:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in'); }); }, 2500);
  }

  // Waitlist popup
  var dlg = document.querySelector('[data-sss-popup]');
  if (dlg && typeof dlg.showModal === 'function') {
    var KEY = 'sss-popup-dismissed';
    var days = parseInt(dlg.getAttribute('data-days'), 10) || 14;
    var delay = (parseInt(dlg.getAttribute('data-delay'), 10) || 12) * 1000;
    var until = 0;
    try { until = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (err) {}
    var dismiss = function () {
      try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (err) {}
      if (dlg.open) dlg.close();
    };
    dlg.querySelectorAll('[data-sss-popup-close]').forEach(function (b) { b.addEventListener('click', dismiss); });
    dlg.addEventListener('cancel', dismiss);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dismiss(); });
    var already = document.querySelector('.sss-signup.is-done');
    if (Date.now() > until && !already && !window.Shopify?.designMode) {
      setTimeout(function () { if (!document.querySelector('dialog[open]')) dlg.showModal(); }, delay);
    }
  }

  // Footer wordmark: fit wall to wall on one line
  function fitAll() {
    document.querySelectorAll('[data-sss-fit]').forEach(function (el) {
      var span = el.firstElementChild; if (!span) return;
      el.style.fontSize = '100px';
      var w = span.getBoundingClientRect().width;
      var target = el.clientWidth;
      if (w > 0 && target > 0) el.style.fontSize = (100 * target / w).toFixed(2) + 'px';
    });
  }
  fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.addEventListener('load', fitAll);
  var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitAll, 80); });

  // After a Shopify customer form post, scroll to the form that was used
  if (/customer_posted=true/.test(location.search)) {
    var done = document.querySelector('.sss-signup.is-done');
    if (done) {
      var ok = done.querySelector('[data-sss-success]');
      if (ok) ok.hidden = false;
      done.scrollIntoView({ block: 'center' });
      try { localStorage.setItem('sss-popup-dismissed', String(Date.now() + 365 * 864e5)); } catch (err) {}
    }
  }
})();
